import React from "react";
import {Outlet, useParams} from "react-router-dom";
import useWorkspaceAggregation from "@/query/workspace/useWorkspaceAggregation";

const WorkspaceWrapper  = () => {
    const { workspaceId } = useParams<{ workspaceId: string}>();
    const {data: workspace} = useWorkspaceAggregation(workspaceId)

    if (workspace) {
        return <Outlet/>
    } else {
        return null
    }

}

export default WorkspaceWrapper